const getPrivateKey = () => {
  return fetch("/.netlify/functions/get-private-key").then((response) => {
    return response.json();
  });
};
export default {
  getPrivateKey: getPrivateKey,
};
